import type { DicomSyntaxConfig } from '../types/dicom';

export const getAcceptedCount = (
  abstractSyntax: keyof DicomSyntaxConfig,
  syntaxConfig: DicomSyntaxConfig
) => {
  const config = syntaxConfig[abstractSyntax];
  return Object.values(config).filter((value) => value === 'accepted').length;
};
